<!-- 
  編集メイン画面
-->
<template>
  <div class="container-fluid">
    <Loading v-if="this.$store.state.isLoading" />
    <AlertDialog v-if="this.$store.state.isAlertDialog" />
    <div class="row header bt-primary justify-content-between align-items-center">
      <div class="col-auto">
        <img
          class="titleimg"
          src="@/assets/acrypro/ambi_logo.png"
          width="100px"
          style="cursor: pointer"
          @click="backhome"
        />
      </div>
    </div>
    <div class="row" style="height: 40px"></div>
    <div class="row">
      <div class="col text-center">
        <p class="noto acry-foreground h3 fw-bold">お問い合わせ</p>
      </div>
    </div>

    <div class="row justify-content-center mt-4 m-auto" style="width: 700px">
      <div class="py-4 text-start">
        <label for="inputName" class="form-label fw-bold">お名前</label
        ><span class="mustlbl ms-2">必須</span>
        <input
          type="text"
          id="inputName"
          v-model="userName"
          class="mt-1 acry-input d-block"
          :class="{ 'acry-input-error': this.userNameError }"
          placeholder=""
        />
      </div>
      <div class="py-4 text-start">
        <label for="inputName" class="form-label fw-bold">メールアドレス</label
        ><span class="mustlbl ms-2">必須</span>
        <input
          type="text"
          id="inputName"
          v-model="userEmail"
          class="mt-1 acry-input d-block"
          :class="{ 'acry-input-error': this.userEmailError }"
          placeholder=""
        />
      </div>
      <div class="py-4 text-start">
        <label for="inputName" class="form-label fw-bold">お問い合わせ内容</label
        ><span class="mustlbl ms-2">必須</span>
        <textarea
          type="text"
          id="inputName"
          v-model="userContent"
          class="mt-1 acry-textarea d-block"
          :class="{ 'acry-input-error': this.userContentError }"
          placeholder=""
        />
      </div>
    </div>

    <div class="row justify-content-center my-3 py-4">
      <button type="button" class="border-0 acry-normal-btn" @click="sendAction">
        <span class="fw-bold">送信</span>
      </button>
    </div>
  </div>
</template>

<script>
import router from "@/router";
import { Logger } from '@/js/utils/Logger.js';
import axios from 'axios'
import config from 'config'
import Loading from "@/components/modal/dialog/Loading.vue";

export default {
  name: "ContactForm",
  components: { Loading },
  data() {
    return {
      userName: "",
      userEmail: "",
      userContent: "",
      userNameError: false,
      userKanaError: false,
      userEmailError: false,
      userContentError: false,
    };
  },
  async mounted() {},
  created: function () {},
  watch: {
    userName() {
      this.userNameError = false;
    },
    userEmail() {
      this.userEmailError = false;
    },
    userContent() {
      this.userContentError = false;
    },
  },
  methods: {
    backhome() {
      router.push("/");
    },
    inputCheck() {
      var errorExist = false;
      if (!this.userName) {
        errorExist = true;
        this.userNameError = true;
      }
      if (!this.userEmail) {
        errorExist = true;
        this.userEmailError = true;
      }
      if (!this.userContent) {
        errorExist = true;
        this.userContentError = true;
      }

      return !errorExist;
    },
    async sendAction() {
      if (!this.inputCheck()) {
        return;
      }

      let info = `\n\n\n${this.userName} 様  \n${this.userEmail}\n`;
      await this.sendMail(
        {
          data:{
            from: this.userEmail,
            display: `${this.userName}様`,
            to: "support@acry.co.jp",
            subject: "AcryProからお問い合わせがありました",
            html: this.userContent + info,
          }
        }
      );
    },
    async sendMail(param){
      const url = (config.isDebug)?
      "https://asia-northeast1-shiptest-bbabd.cloudfunctions.net/SendMail":
      "https://asia-northeast1-shiptest-bbabd.cloudfunctions.net/SendMail";

      this.$store.commit("showLoadingMessage", "送信中…しばらくお待ちください");

      return axios.post(url, param)
          .then((response) => {
            Logger.debug(response);
            this.$store.commit("hideLoading");
            router.push("/contactcomplete");
          })
          .catch((e) => {
            Logger.error(e);
            this.$store.commit("hideLoading");
            alert("内容の送信に失敗しました\n入力内容をご確認ください");
          });
    },
  },
  computed: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mustlbl {
  color: white;
  background: #bc6665;
  border-radius: 3px;
  padding: 5px 12px 5px 12px;
}
.acry-input {
  width: 300px;
  height: 40px;
  padding-left: 10px;
}
.acry-textarea {
  border: solid #cdcdcd 1px;
  border-radius: 4px;
  width: 100%;
  height: 200px;
  padding-left: 10px;
}
.acry-input-error {
  border: 1px solid #bc6665;
}
</style>
